import React from 'react';
import { Box } from '@mui/material';

// The page's content column, so every screen has the same margins.
//
// They did not. Files padded itself 32px at the sides against everyone
// else's 24px, and the maximum width was 1180 on the Dashboard, 1400 on
// Operations, 1180 on Users, 900 on Settings and 1180 on Bug reports — so
// the column jumped width every time you changed tab.
//
// There is one width and it is centred, which means the page title starts
// at exactly the same x on every screen. That last part is why there is no
// `narrow` variant: a narrower column that is also centred puts Settings'
// heading 130px further right than every other heading, which is precisely
// the inconsistency this is here to remove. A screen that wants a shorter
// measure — a form, a run's timeline — constrains its own cards inside this
// column and stays left-aligned with everything else.

export const CONTENT_MAX_WIDTH = 1280;

/** For forms and prose inside a PageBody. Left-aligned, never centred. */
export const READING_WIDTH = 880;

const PageBody: React.FC<{
  children: React.ReactNode;
  /** Fill the column instead of capping it — for a split view or a map. */
  fluid?: boolean;
  /** The page manages its own height (a map). */
  fill?: boolean;
}> = ({ children, fluid, fill }) => (
  <Box
    sx={{
      px: { xs: 2, sm: 3 },
      py: 3,
      ...(fill && { height: '100%', display: 'flex', flexDirection: 'column', minHeight: 0 }),
    }}
  >
    <Box
      sx={{
        width: '100%',
        ...(fluid ? {} : { maxWidth: CONTENT_MAX_WIDTH, mx: 'auto' }),
        ...(fill && { flex: 1, display: 'flex', flexDirection: 'column', minHeight: 0 }),
      }}
    >
      {children}
    </Box>
  </Box>
);

export default PageBody;
